import "./App.scss";
import Dashboard from "./pages/Dashboard";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import QuestionList from "./pages/Question";
import UserList from "./pages/User";
import Login from "./components/Login";
import Unauthorized from "./components/Unauthorized";
import Chat from "./pages/Chat";
import Campaigns from "./pages/Campaigns";
import Reports from "./pages/Reports";
import Notifications from "./pages/Notifications";
import Profile from "./pages/Profile";
import ClientTeam from "./pages/ClientTeam";
import { AuthService } from "./services/AuthService";
import AdminPanel from "./pages/AdminPanel";
import NotificationControl from "./pages/NotificationControl";

const RequireAuth: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const location = useLocation();
  if (!AuthService.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
};

const RequireAdmin: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const location = useLocation();
  if (!AuthService.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!AuthService.isAdmin()) {
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
};

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminPanel />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/chats"
          element={
            <RequireAdmin>
              <Chat />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/campanhas"
          element={
            <RequireAdmin>
              <Campaigns />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/contextos"
          element={
            <RequireAdmin>
              <QuestionList />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/usuarios"
          element={
            <RequireAdmin>
              <UserList />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/notificacoes"
          element={
            <RequireAdmin>
              <NotificationControl />
            </RequireAdmin>
          }
        />

        <Route
          path="/"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/relatorios"
          element={
            <RequireAuth>
              <Reports />
            </RequireAuth>
          }
        />
        <Route
          path="/notificacoes"
          element={
            <RequireAuth>
              <Notifications />
            </RequireAuth>
          }
        />
        <Route
          path="/perfil"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />
        <Route
          path="/equipe"
          element={
            <RequireAuth>
              <ClientTeam />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
